<template>
	<div class="authentication-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{fuwuInfo.title || ''}}</div>
				<!-- <div class="des">斩获碳认证，为低碳转型添硬核背书</div> -->
				<div class="btns">
					<el-button class="lijishiyong" type="whitetrans" @click="apply">立即申请</el-button>
				</div>
			</div>
		</div>
		<!-- 服务介绍 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="serviceIntroduce">
				<div class="serviceIntroduce-container w1200">
					<div class="heading">服务介绍</div>
					<div class="heading-des">
						对于协会认可、企业选定的第三方认证机构，平台提供待认证的报告材料和数据信息，认证机构在平台完成审核，并出具认证证书，建立“数据采集-校验-存证”的全流程协同机制。企业填报的活动数据经第三方机构线下/线上核查、凭证核验及交叉验证，确保数据来源真实、口径统一。平台提供文件存证入口，对活动数据的佐证文件实现留存与管理，从源头保障碳足迹核算的基础数据质量。
					</div>
				</div>
			</div>
		</div>
		<!-- 步骤 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="steps">
				<div class="steps-container w1200">
					<div class="heading">集装箱产品碳足迹认证流程</div>
					<!-- <div class="heading-des">
						通过碳核算，组织可以更好地了解和管理其碳足迹，制定减排战略和行动计划
						<br />
						以达到减少温室气体排放的目标，促进可持续发展和应对气候变化
					</div> -->
					<div class="list">
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">产品碳足迹核算</div>
							<!-- <div class="des">企业填报核算相关基础数据、选择碳排因子等</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">企业申请认证</div>
							<!-- <div class="des">测量和计算特定产品碳足迹</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">认证机构线下/线上核查</div>
							<!-- <div class="des">收集和整理与活动相关的数据，包括能源使用、运输、原材料采购等，用于计算碳排放</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">认证机构出具证书</div>
							<!-- <div class="des">生成碳足迹报告，详细说明排放数据、计算方法和数据来源，向利益相关者和公众披露</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">认证证书上传平台</div>
							<!-- <div class="des">根据需要选择第三方机构</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 优势 -->
		<!-- <div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="advantage">
				<div class="advantage-container w1200">
					<div class="heading">碳认证的优势主要体现在5个方面</div>
					<div class="heading-des">
						碳认证不仅有助于企业履行环保承诺和社会责任，还可以为企业带来
						<br />
						商业上的多重好处，推动其向更可持续和环保的方向发展
					</div>
				</div>
				<img class="cover" src="@/assets/tmp/026.png" alt="" />
			</div>
		</div> -->
		<Foot></Foot>
	</div>
</template>

<script>
	import { webInfo } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
export default {
	name: 'authentication',
	components: { Head, Foot },
	data() {
		return {
			fuwuInfo: webInfo.sidafuwu[1]
		};
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		},
		apply() {
			if (this.checkUser()) {
				if (this.uInfo && this.uInfo.roles && this.uInfo.certifiedStatus == '2') {
					if (this.uInfo.isAdmin) {
						window.open('/org/home/', '_self');
					} else if (
						(!this.uInfo.isAdmin &&
							this.uInfo.roles &&
							(this.uInfo.roles.indexOf('manager') != -1 ||
								this.uInfo.username.indexOf('AdminMaster01') != -1 ||
								this.uInfo.username.indexOf('AdminMaster02') != -1)) ||
						this.uInfo.roles.indexOf('manager_userSet') != -1
					) {
						window.open('/org/admin/', '_self');
					} else if (!this.uInfo.isAdmin && this.uInfo.roles && this.uInfo.roles.indexOf('government') != -1) {
						window.open('/org/admin/', '_self');
					} else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('authentication') != -1 || this.uInfo.roles.indexOf('auth_userSet') != -1)) {
						window.open('/org/authority/', '_self');
					} else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('company') != -1 || this.uInfo.roles.indexOf('home_userSet') != -1)) {
						window.open('/org/home/', '_self');
					}
				} else if (this.uInfo && this.uInfo.certifiedStatus) {
					if (this.uInfo.certifiedStatus == 1) {
						this.toast({
							type: 'warning',
							message: '实名审核中，请等待审核结果'
						});
					} else if (this.uInfo.certifiedStatus == 2) {
						this.toast({
							type: 'warning',
							message: '暂无进入工作台角色权限，请联系管理员'
						});
					} else if (this.uInfo.certifiedStatus == 3) {
						this.toast({
							type: 'warning',
							message: '实名失败，请重新提交'
						});
					}
				}
			} else {
				this.toast({
					type: 'warning',
					message: '请先登录'
				});
				this.$router.push({
					name: 'login'
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.authentication-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/025.png');
		background-size: cover;
		height: 334px;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 93px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
			}
			.btns {
				margin-top: 40px;
				display: flex;
				.lijishiyong {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					width: 160px;
					height: 50px;
					border-radius: 0px;
					// font-weight: bold;
					font-size: 16px;
					line-height: 22px;
				}
			}
		}
	}
	.serviceIntroduce {
		background: #f6f8fc;
		padding-bottom: 45px;
		.serviceIntroduce-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				width: 1150px;
				line-height: 30px;
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				text-align: justify;
				text-align-last: center;
			}
			
		}
	}
	.steps {
		.steps-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.list {
				align-self: stretch;
				margin-top: 56px;
				margin-bottom: 45px;
				display: flex;
				.item {
					// width: 215px;
					flex: 1;
					padding-left: 15px;
					padding-right: 15px;
					display: flex;
					flex-direction: column;
					align-items: center;
					.svg-tianbao {
						width: 70px;
						height: 70px;
					}
					.label {
						margin-top: 27px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
						text-align: center;
					}
					.des {
						margin-top: 20px;
						font-size: 14px;
						color: #636d7e;
						line-height: 20px;
						text-align: justify;
						text-align-last: center;
					}
				}
			}
		}
	}
	.advantage {
		display: flex;
		flex-direction: column;
		.advantage-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 43px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				margin-bottom: 60px;
				margin-top: 21px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.cover {
				width: 100%;
				height: auto;
			}
		}
	}
}
</style>
